var a = Object.defineProperty;
var d = (l, t, e) => t in l ? a(l, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[t] = e;
var s = (l, t, e) => (d(l, typeof t != "symbol" ? t + "" : t, e), e);
import { fabric as o } from "fabric";
const i = {
  idle: {
    default: {
      selectable: !1,
      strokeWidth: 2,
      strokeDashArray: void 0,
      originX: "center",
      originY: "center"
    },
    light: {
      stroke: "#49565D"
    },
    dark: {
      stroke: "white"
    }
  },
  dragStart: {
    default: {
      strokeDashArray: [5, 5]
    },
    light: {
      fill: "#49565D"
    },
    dark: {
      fill: "white"
    }
  },
  select: {
    default: {
      selectable: !1,
      strokeWidth: 2,
      strokeDashArray: void 0,
      originX: "center",
      originY: "center"
    },
    light: {
      stroke: "#49565D"
    },
    dark: {
      stroke: "white"
    }
  },
  selectedPOI: {
    default: {
      selectable: !1,
      strokeWidth: 2,
      strokeDashArray: void 0,
      originX: "center",
      originY: "center"
    },
    light: {
      stroke: "#49565D"
    },
    dark: {
      stroke: "white"
    }
  }
};
class k extends o.Line {
  constructor(e, r) {
    r = {
      ...r,
      ...i.idle.default,
      ...i.idle[r.styleType]
    };
    super(e, r);
    s(this, "objType");
    s(this, "styleType");
    s(this, "updateStyle", (e, r = "idle") => {
      this.styleType = e, this.set({
        ...i.idle.default,
        ...i.idle[this.styleType],
        ...i[r].default,
        ...i[r][this.styleType]
      });
    });
    this.objType = "LeaderLine", this.styleType = r.styleType;
  }
}
export {
  k as LeaderLine,
  i as lineStyles
};
//# sourceMappingURL=index.es249.js.map
